/* eslint-disable */
import { LoadingOutlined, ZoomOutOutlined } from '@ant-design/icons';
import { Button, Card, Col, DatePicker, Form, Input, Row, Spin, Table, Tabs, Tag, Tooltip, message } from 'antd';
import type { ColumnsType, SorterResult } from 'antd/es/table/interface';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import InstitutionUserService from '../../services/InstitutionUserService';
import { parseMoneyAmount } from '../../utils/parseMoneyAmount';
import { RefundStatsRangeAlert } from '../refund/RefundStatsRangeAlert';
import styles from '../../asserts/css/PublicTreasury.module.css';


const antIcon = <LoadingOutlined style={{ fontSize: 'var(--base-font-size)', color: '#37762F' }} spin />
const { RangePicker } = DatePicker
interface DataType {
  index: any;
  key: React.Key
  bank_code: string
  transaction_reference: string
  debit_account_number: string
  debit_account_name: string
  beneficiary_account_name: string
  beneficiary_bank_name: string
  beneficiary_account_number: string
  transaction_currency: string
  amount: number
  reason: string
  status: string
  created_at: string;
  updated_at: string;
  column: string;
  totalPayments: string;
  amountRequestedToBeRefund: string;
  amountRequestedToBeRefundedInProgressStatus: string;
  TotalNumberOfApplicantRequestedRefund: string;
  notRequestedBidders: string;
}
const PublicTreasury: React.FC = () => {
  const [form] = Form.useForm()
  const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}')
  const navigate = useNavigate()
  const [filterStatus, setfilterStatus] = useState('')
  const [clear, setClear] = useState(false)
  const [refundRequestList, setRefundRequestList] = useState<DataType[]>([]);
  const [loading, setLoading] = useState(false);
  const [sortedInfo, setSortedInfo] = useState<SorterResult<DataType>>({})
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const [bailiffRefundRequestList, setBailiffRefundRequestList] = useState<DataType[]>([]);
  const [stats, setStats] = React.useState<DataType | null>(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [activeTab, setActiveTab] = useState('bidders'); // Default tab
  const [appliedFilters, setAppliedFilters] = useState<string[]>([]);
  const [token, setToken] = useState('')
  const [BiddersAmountRequestedToBeRefund, setBiddersAmountRequestedToBeRefund] = useState('')
  const [BailiffAmountRequestedToBeRefunded, setBailiffAmountRequestedToBeRefunded] = useState('')
  const [NewBiddersAmountRequestedToBeRefunded, setNewBiddersAmountRequestedToBeRefunded] = useState('')
  const [NewBailiffAmountRequestedToBeRefunded, setNewBailiffAmountRequestedToBeRefunded] = useState('')
  const [totalPaidForRange, setTotalPaidForRange] = useState('')

  useEffect(() => {
    // Fetch data on component mount
    OnRefundRequestSearch();
  }, []);

  useEffect(() => {
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      async function fetchRefundStats () {
        setLoading(true)
        try {
          const response = await InstitutionUserService.viewRefundStatsByRefundStartDate(fromDate, toDate, token)
          const biddersAmountRequestedToBeRefund = response.data?.biddersAmountRequestedToBeRefund
          setBiddersAmountRequestedToBeRefund(response.data?.biddersAmountRequestedToBeRefund)
          const bailiffAmountRequestedToBeRefunded = response.data?.bailiffAmountRequestedToBeRefunded
          setBailiffAmountRequestedToBeRefunded(response.data?.bailiffAmountRequestedToBeRefunded)
          const newBiddersAmountRequestedToBeRefunded = response.data?.newBiddersAmountRequestedToBeRefunded
          setNewBiddersAmountRequestedToBeRefunded(response.data?.newBiddersAmountRequestedToBeRefunded)
          const newBailiffAmountRequestedToBeRefunded = response.data?.newBailiffAmountRequestedToBeRefunded
          setNewBailiffAmountRequestedToBeRefunded(response.data?.newBailiffAmountRequestedToBeRefunded)
          const tp = response.data?.totalPayments
          setTotalPaidForRange(tp != null && tp !== '' ? String(tp) : '')
        } catch (err) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          setError('Failed to fetch refund stats')
          // eslint-disable-next-line no-console
          console.error(err)
        } finally {
          setLoading(false)
        }
      }

      void fetchRefundStats()
    },
    [fromDate, toDate, token])

  useEffect(() => {
    if (activeTab === 'bidders') {
      const total = refundRequestList.reduce((acc, curr) => acc + curr.amount, 0);
      setTotalAmount(total);
    } else if (activeTab === 'bailiffs') {
      const total = bailiffRefundRequestList.reduce((acc, curr) => acc + curr.amount, 0);
      setTotalAmount(total);
    }
  }, [refundRequestList, bailiffRefundRequestList, activeTab]);

  React.useEffect(() => {
    InstitutionUserService.RefundRequestStats()
      .then((res: any) => {
        setStats(res.data);
      })
      .catch((err) => {
        message.error(err?.message);
      });
  }, []);

  useEffect(() => {
    OnRefundRequestSearch()
    // eslint-disable-next-line
  }, [clear, pagination.current, pagination.pageSize, fromDate, toDate])

  const handleTableChange = (pagination: any) => {
    setPagination(pagination)
  }
  let filter = ''
  if (filterStatus) {
    filter = filter + 'Type'
  }
  if (fromDate) {
    filter = filter === '' ? filter + 'From Date' : filter + ', From Date'
  }
  if (toDate) {
    filter = filter === '' ? filter + 'To Date' : filter + ', To Date'
  }

  const updateRefundRequestStatus = async (): Promise<void> => {
    try {
      const refundRequests = refundRequestList.map(item => ({ transaction_reference: item.transaction_reference }));
      const response = await InstitutionUserService.updateRefundRequestStatus({ RefundRequests: refundRequests });

      if (response.status === 200) {
        // Handle success
      } else {
        // Handle unexpected response status
      }
    } catch (error) {
      // Handle error
    }
  };

  const updateBailiffRefundRequestStatus = async (): Promise<void> => {
    try {
      const createdBy = userInfo?.id || 'default_user_id';
      const bailiffRefundRequests = bailiffRefundRequestList.map(item => {
        const phone = String(
          (item as { bailiff_phone_number?: string }).bailiff_phone_number ??
          (item as { bailiffPhoneNumber?: string }).bailiffPhoneNumber ??
          ''
        ).trim()
        return {
          transaction_reference: item.transaction_reference,
          created_by: createdBy,
          ...(phone !== '' ? { bailiff_phone_number: phone } : {})
        }
      })
      const response = await InstitutionUserService.updateBailiffRefundRequestStatus({ BailiffRefundRequests: bailiffRefundRequests });

      if (response.status === 200) {
        // Handle success
      } else {
        // Handle unexpected response status
      }
    } catch (error) {
      // Handle error
    }
  };

  const columnsToDownload = [
    'bank_code',
    'transaction_reference',
    'debit_account_number',
    'debit_account_name',
    'beneficiary_bank_name',
    'beneficiary_account_name',
    'beneficiary_account_number',
    'amount',
    'transaction_currency',
    'reason'
  ];
  // Convert column names to uppercase and remove underscores
  const formattedColumns = columnsToDownload.map(column =>
    column.toUpperCase().replace(/_/g, ' ')
  );

  const convertToCSV = (data: { [x: string]: any; }[], maxColumns: number = 10) => {
    const columnsToSkip = ['refund_request_id', 'bailiff_refund_request_id'];
    const originalColumns = Object.keys(data[0])
      .filter(col => !columnsToSkip.includes(col))
      .slice(0, maxColumns);

    // Remove underscores and convert to uppercase for display
    const formattedColumns = originalColumns.map(column =>
      column.toUpperCase().replace(/_/g, ' ')
    );

    // Create CSV header
    const header = formattedColumns.join(',') + '\n';

    // Create CSV rows
    const rows = data.map((row: { [x: string]: any; }) => {
      const rowData = formattedColumns.map((col) => {
        // Convert header back to original format to match data keys
        const column = col.toLowerCase().replace(/_/g, ' ');
        let value = row[column];
        if (value === undefined || value === null) return '';
        value = value.toString().replace(/"/g, '""'); // Escape quotes
        return `"${value}"`; // Enclose in quotes
      }).join(',');

      return rowData;
    }).join('\n');

    return header + rows;
  };

  const downloadCSV = (csvContent: string, fileName: string, maxColumns: number = 10) => {
    const lines = csvContent.split('\n');
    const headerLine = lines[0].split(',');
    const transactionReferenceIndex = headerLine.indexOf('TRANSACTION REFERENCE');
    const debitAccountNumberIndex = headerLine.indexOf('DEBIT ACCOUNT NUMBER');
    const beneficiaryAccountNumberIndex = headerLine.indexOf('BENEFICIARY ACCOUNT NUMBER');
    const formattedLines = lines.map((line, lineIndex) => {
      const columns = line.split(',').slice(0, maxColumns);

      if (lineIndex > 0 && transactionReferenceIndex !== -1) {
        columns[transactionReferenceIndex] = '';
      }

      if (debitAccountNumberIndex !== -1) {
        // Remove any single quotes and ensure proper CSV formatting
        columns[debitAccountNumberIndex] = `"${columns[debitAccountNumberIndex].replace(/'/g, "''").replace(/"/g, '""')}"`;
      }

      if (beneficiaryAccountNumberIndex !== -1) {
        // Remove any single quotes and ensure proper CSV formatting
        columns[beneficiaryAccountNumberIndex] = `"${columns[beneficiaryAccountNumberIndex].replace(/'/g, "''").replace(/"/g, '""')}"`;
      }

      const formattedColumns = columns.map(column => {
        return column.replace(/"/g, ''); // Remove quotes
      }).join(',');

      return formattedColumns;
    });
    // Join all formatted lines into the final CSV content
    const formattedCSV = formattedLines.join('\n');
    const blob = new Blob([formattedCSV], { type: 'text/csv;charset=utf-8;' });

    if ((navigator as any).msSaveBlob) { // For IE 10+
      (navigator as any).msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error('File download not supported on this browser.');
      }
    }
  };

  const handleDownloadExcel = async (): Promise<void> => {
    try {
      let dataToDownload: DataType[] = [];
      if (activeTab === 'bidders') {
        dataToDownload = refundRequestList;
        await updateRefundRequestStatus();
      } else if (activeTab === 'bailiffs') {
        dataToDownload = bailiffRefundRequestList;
        await updateBailiffRefundRequestStatus();
      }

      const csvContent = convertToCSV(dataToDownload, 10);
      downloadCSV(csvContent, 'BankTransfersTemplate.csv');
    } catch (error) {
      console.error('Error occurred while downloading CSV:', error);
      message.warning("Error occurred while downloading CSV and updating refund request status.");
    }
  };
  // Converts data to sheet format and then to an Excel file
  const convertToExcel = (data: { [x: string]: any }[], maxColumns: number = 10): XLSX.WorkBook => {
    console.log('Converting data to Excel format...');

    // Define columns to be skipped
    const columnsToSkip = ['refund_request_id', 'bailiff_refund_request_id'];

    // Extract headers while excluding columns to be skipped
    const originalColumns = Object.keys(data[0])
      .filter(col => !columnsToSkip.includes(col))
      .slice(0, maxColumns);

    console.log('Original Columns:', originalColumns);

    const sheetData = data.map(row => {
      const rowData: { [key: string]: any } = {};
      originalColumns.forEach(column => {
        // Convert header back to original format to match data keys
        const columnKey = column.toLowerCase().replace(/ /g, '_');
        rowData[column] = row[columnKey] || '';
      });
      return rowData;
    });

    console.log('Sheet Data:', sheetData);
    const ws = XLSX.utils.json_to_sheet(sheetData, { header: originalColumns });
    // Create a workbook and add the worksheet to it
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    console.log('Excel workbook created.');

    return wb;
  };

  const downloadExcel = (wb: XLSX.WorkBook, fileName: string) => {
    console.log('Preparing to download Excel file...');

    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    if ((navigator as any).msSaveBlob) { // For IE 10+
      (navigator as any).msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error('File download not supported on this browser.');
      }
    }

    console.log('Excel file downloaded.');
  };

  // Handle the process of downloading the Excel file
  const handleDownloadExcelFile = async (): Promise<void> => {
    try {
      console.log('Handling download of Excel file...');

      let dataToDownload: { [x: string]: any }[] = [];
      if (activeTab === 'bidders') {
        dataToDownload = refundRequestList;
      } else if (activeTab === 'bailiffs') {
        dataToDownload = bailiffRefundRequestList;
      }

      console.log('Data to download:', dataToDownload);

      const wb = convertToExcel(dataToDownload, 10);
      downloadExcel(wb, 'New Refund Request Report.xlsx');
    } catch (error) {
      console.error('Error occurred while downloading Excel:', error);
      message.warning("Error occurred while downloading Excel and updating refund request status.");
    }
  };

  const clearFilter = (): void => {
    setfilterStatus('')
    form.setFieldValue('filterStatus', '')
    form.setFieldValue('range_picker', ['', ''])
    setFromDate('')
    setToDate('')
    setClear(true)
  }

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  useEffect(() => {
    OnRefundRequestSearch();
  }, [activeTab, pagination.pageSize, pagination.current, filterStatus, fromDate, toDate]);

  const OnRefundRequestSearch = (event?: any): void => {
    setLoading(true);
    const service = activeTab === 'bidders' ? InstitutionUserService.ViewUpdatedToPublicTreasury : InstitutionUserService.GetBailiffRefundRequestList;
    service(
      pagination.pageSize as number,
      pagination.current as number,
      event?.target?.value,
      fromDate,
      toDate
    )
      .then((res: any) => {
        if (res.status === 200) {
          if (activeTab === 'bidders') {
            setRefundRequestList(res?.data);
          } else if (activeTab === 'bailiffs') {
            setBailiffRefundRequestList(res?.data);
          }
          setPagination((prev) => ({
            ...prev,
            total: res?.meta?.total
          }));
          setLoading(false);
        }
      })
      .catch((err: any) => {
        if (err?.message !== 'Operation canceled due to new request.') {
          message.error(err?.message);
        }
        setLoading(false);
      });
  };

  const biddersColumns: ColumnsType<DataType> = [
    {
      title: 'No.',
      dataIndex: 'index',
      key: 'index',
      // width: 90, // Remove width restriction
      render: (text, record, index) => {
        const pageNumber = pagination.current || 1
        const pageSize = pagination.pageSize || 10
        const globalIndex = (pageNumber - 1) * pageSize + (index + 1)
        return <span>{globalIndex}</span>;
      },
      sorter: (a, b) => a.index - b.index,
      sortOrder: sortedInfo.columnKey === 'index' ? sortedInfo.order : null,
      ellipsis: false, // No ellipsis
    },
    {
      title: 'Transaction Reference',
      dataIndex: 'transaction_reference',
      key: 'transaction_reference',
      // width: 100,
      sorter: (a: any, b: any) => a?.transaction_reference.localeCompare(b?.transaction_reference),
      sortOrder: sortedInfo?.columnKey === 'transaction_reference' ? sortedInfo?.order : null,
      ellipsis: false,
      render: (text: string, record: any) => (
        <Tooltip
          title={`\n                Debit Bank Name: ${record.debit_account_name}\n                Debit Bank Number: ${record.debit_account_number}\n                Reason: ${record.reason}\n            `}>
          <span>{text}</span>
        </Tooltip>
      ),
    },
    {
      title: 'Bailiff Assignee',
      dataIndex: 'bailiff_assignee',
      key: 'bailiff_assignee',
      // width: 200,
      sorter: (a: any, b: any) =>
        a?.bailiff_assignee.localeCompare(b?.bailiff_assignee),
      sortOrder: sortedInfo?.columnKey === 'bailiff_assignee' ? sortedInfo?.order : null,
      ellipsis: false,
      render: (text: string, record: any) => (
        <Tooltip
          title={`\n                Debit Bank Name: ${record.debit_account_name}\n                Debit Bank Number: ${record.debit_account_number}\n                Reason: ${record.reason}\n            `}>
          <span>{text}</span>
        </Tooltip>
      ),
    },
    {
      title: 'Bidder Names',
      dataIndex: 'bidders.full_name',
      key: 'full_name',
      // width: 200,
      sorter: (a: any, b: any) => a?.bidders?.full_name.localeCompare(b?.bidders?.full_name),
      sortOrder: sortedInfo?.columnKey === 'full_name' ? sortedInfo?.order : null,
      ellipsis: false,
      render: (text: string, record: any) => (
        <Tooltip
          title={`\n        Debit Bank Name: ${record.debit_account_name}\n        Debit Bank Number: ${record.debit_account_number}\n        Reason: ${record.reason}\n      `}
        >
          <span>{record?.bidders?.full_name}</span>
        </Tooltip>
      ),
    },
    {
      title: 'Bidder Phone Number',
      dataIndex: 'bidders.phone_number',
      key: 'phone_number',
      // width: 150,
      sorter: (a: any, b: any) => a?.bidders?.phone_number.localeCompare(b?.bidders?.phone_number),
      sortOrder: sortedInfo?.columnKey === 'phone_number' ? sortedInfo?.order : null,
      ellipsis: false,
      render: (text: string, record: any) => (
        <Tooltip
          title={`\n                Debit Bank Name: ${record.debit_account_name}\n                Debit Bank Number: ${record.debit_account_number}\n                Reason: ${record.reason}\n            `}>
          <span>{record?.bidders?.phone_number}</span>
        </Tooltip>
      ),
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      // width: 130,
      render: (_text: any, record: any) => {
        const amount = parseInt(record?.amount, 10)
        return `${amount.toLocaleString()} Rwf`;
      },
      sorter: (a: any, b: any) => Number(a?.amount) - Number(b?.amount),
      sortOrder: sortedInfo?.columnKey === 'amount' ? sortedInfo?.order : null,
      ellipsis: false
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (text: any, record: any) => {
        const tagColorClass = record?.status === 'RECEIVED REQUEST' ? 'custom-tag-success' : 'custom-tag-error';

        return (
          <Tag className={`custom-tag ${tagColorClass}`}>
            {record?.status}
          </Tag>
        );
      },
      key: 'status',
      // width: 150,
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
      sortOrder: sortedInfo?.columnKey === 'status' ? sortedInfo?.order : null,
      ellipsis: false,
    },
    {
      title: 'Action',
      dataIndex: 'action',
      render: (text: any, record: any) => (
        <div className="w-[60%] flex justify-center icon-container">
          <i
            className="far fa-eye cursor-pointer icon-style"
            onClick={() => {
              navigate('/view-to-public-treasury-request', { state: record })
            }}
          ></i>
        </div>
      )
    }
  ]
  // Function to calculate total amount
  return (
    <div className="w-full" style={{ paddingRight: '20px' }}>
      {/* Add custom styles for table rows */}
      <style>{`
        .table-row-light {
          background-color: #ffffff;
        }
        .table-row-dark {
          background-color: #ffffff;
        }
        .table-row-light:hover,
        .table-row-dark:hover {
          background-color: #f9fafb !important;
        }
        .ant-table-thead > tr > th {
          background-color: #f8f8f8 !important;
          border-bottom: 1px solid #e5e7eb !important;
          border-right: 1px solid #e5e7eb !important;
          font-weight: 600 !important;
          color: #374151 !important;
          font-size: 14px !important;
          text-align: left !important;
          padding: 12px 16px !important;
          font-family: 'Avenir', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif !important;
        }
        .ant-table-thead > tr > th:last-child {
          border-right: none !important;
        }
        .ant-table-tbody > tr > td {
          border-bottom: 1px solid #e5e7eb !important;
          border-right: 1px solid #e5e7eb !important;
          padding: 12px 16px !important;
          text-align: left !important;
          font-size: 14px !important;
          color: #1f2937 !important;
        }
        .ant-table-tbody > tr > td:last-child {
          border-right: none !important;
        }
        .ant-table-column-sorter {
          color: #9ca3af !important;
          margin-left: 4px !important;
        }
        .ant-table-column-sorter-up,
        .ant-table-column-sorter-down {
          color: #9ca3af !important;
          font-size: 12px !important;
        }
        .ant-table-column-sorter-up.active,
        .ant-table-column-sorter-down.active {
          color: #374151 !important;
        }
      `}</style>
      
      {/* Enhanced page header */}
      <div className="px-5 py-4 border-b-slate-200 border border-solid w-full" style={{
        background: 'linear-gradient(135deg, var(--refund-theme-bg) 0%, var(--refund-theme-bg-soft) 100%)',
        borderRadius: '0 0 12px 12px',
        marginBottom: '20px'
      }}>
        <div className="flex justify-between items-center">
          <div className="text-title font-bold flex items-center">
            <div style={{
              background: 'linear-gradient(135deg, var(--refund-theme-primary) 0%, #4a7c59 100%)',
              borderRadius: '50%',
              width: '48px',
              height: '48px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '16px',
              boxShadow: '0 4px 12px rgba(55, 118, 47, 0.3)'
            }}>
              <span style={{ fontSize: '24px' }}>🏛️</span>
            </div>
            <div>
              <h2 className="text-title font-bold" style={{
                margin: 0,
                background: 'linear-gradient(135deg, var(--refund-theme-primary) 0%, #4a7c59 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                Public Treasury
              </h2>
              <p style={{
                margin: '4px 0 0 0',
                fontSize: '14px',
                color: '#6b7280',
                fontWeight: '500'
              }}>
                Public Treasury Management • Financial Oversight Dashboard
              </p>
            </div>
          </div>
        </div>
      </div>
      <RefundStatsRangeAlert fromDate={fromDate} toDate={toDate} />
      {/* Enhanced stats section with hover effects - Responsive */}
      <div style={{
        padding: '20px',
        backgroundColor: 'var(--refund-theme-bg)',
        borderRadius: '8px',
        margin: '0 20px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}
      className={styles['stats-container']}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={5}>
            <div
              className="stat-card"
              style={{
                width: '100%',
                background: 'var(--refund-theme-bg)',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid var(--refund-theme-border)',
                textAlign: 'center',
                color: '#111827',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                Total Amount Requested
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'var(--refund-theme-primary)' }}>
                {((parseMoneyAmount(BailiffAmountRequestedToBeRefunded) ?? 0) + (parseMoneyAmount(BiddersAmountRequestedToBeRefund) ?? 0)).toLocaleString()} Rwf
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={5}>
            <div
              className="stat-card"
              style={{
                width: '100%',
                background: 'var(--refund-theme-bg)',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid var(--refund-theme-border)',
                textAlign: 'center',
                color: '#111827',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                New Amount Requested
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'var(--refund-theme-primary)' }}>
                {((parseMoneyAmount(NewBiddersAmountRequestedToBeRefunded) ?? 0) + (parseMoneyAmount(NewBailiffAmountRequestedToBeRefunded) ?? 0)).toLocaleString()} Rwf
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={4} xl={5} xxl={5}>
            <div
              className="stat-card"
              style={{
                width: '100%',
                background: 'var(--refund-theme-bg)',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid var(--refund-theme-border)',
                textAlign: 'center',
                color: '#111827',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                Remaining to Request
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'var(--refund-theme-primary)' }}>
                {Math.max(
                  0,
                  parseMoneyAmount(totalPaidForRange) - (parseMoneyAmount(BiddersAmountRequestedToBeRefund) + parseMoneyAmount(BailiffAmountRequestedToBeRefunded))
                ).toLocaleString()} Rwf
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={4} xl={5} xxl={5}>
            <div
              className="stat-card"
              style={{
                width: '100%',
                background: 'var(--refund-theme-bg)',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid var(--refund-theme-border)',
                textAlign: 'center',
                color: '#111827',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                Total Paid Amount
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'var(--refund-theme-primary)' }}>
                {(parseMoneyAmount(totalPaidForRange)).toLocaleString()} Rwf
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={4} xl={4} xxl={4}>
            <div
              className="stat-card"
              style={{
                width: '100%',
                background: 'var(--refund-theme-bg)',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid var(--refund-theme-border)',
                textAlign: 'center',
                color: '#111827',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                Total Refunded Amount
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'var(--refund-theme-primary)' }}>
                {(((parseMoneyAmount(BiddersAmountRequestedToBeRefund) + parseMoneyAmount(BailiffAmountRequestedToBeRefunded))) - ((parseMoneyAmount(NewBiddersAmountRequestedToBeRefunded)) + (parseMoneyAmount(NewBailiffAmountRequestedToBeRefunded)))).toLocaleString()} Rwf
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div className="px-2">
        <div className="py-0 mb-0">
          <Form
            name="normal_login"
            layout="vertical"
            className="login-form p-10"
            initialValues={{ remember: true }}
            form={form}
          >
            <Card
              className="bg-gradient-to-r from-blue-50 to-indigo-50"
              style={{
                borderRadius: '12px',
                border: '1px solid #e0e7ff',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
              }}
            >
              <Row gutter={[16, 16]}>
                <Col xs={24} xl={18}>
                  <Form.Item
                    name="range_picker"
                    label={
                      <span style={{
                        fontWeight: '600',
                        color: '#374151',
                        fontSize: '16px'
                      }}>
                        📅 Select Date Range
                      </span>
                    }
                  >
                    <RangePicker
                      size="large"
                      className="w-full"
                      allowClear
                      style={{
                        borderRadius: '8px',
                        border: '2px solid #e5e7eb',
                        transition: 'border-color 0.2s ease'
                      }}
                      onChange={(value, valueString) => {
                        setFromDate(valueString[0])
                        setToDate(valueString[1])
                      }}
                    />
                  </Form.Item>
                  {filter !== ''
                    ? (
                      <div className="flex flex-col md:flex-row justify-between pb-2.5 md:pb-0 gap-2">
                        <div>
                          Applied filters: <span className="font-medium">{filter}</span>
                        </div>
                        <div
                          className="bg-black text-center py-0.5 px-2.5 text-white rounded-sm font-medium cursor-pointer"
                          onClick={clearFilter}
                        >
                          Clear X
                        </div>
                      </div>
                    )
                    : (
                      ''
                    )}
                </Col>
                <Col xs={24} xl={6}>
                  <Form.Item>
                    <Button
                      type="primary"
                      size="large"
                      className="w-full font-bold"
                      disabled={fromDate.length === 0 || toDate.length === 0}
                      style={{
                        background: (fromDate.length === 0 || toDate.length === 0)
                          ? '#d1d5db'
                          : 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                        border: 'none',
                        borderRadius: '8px',
                        height: '48px',
                        fontSize: '16px',
                        fontWeight: '600',
                        boxShadow: (fromDate.length === 0 || toDate.length === 0)
                          ? 'none'
                          : '0 4px 12px rgba(16, 185, 129, 0.3)',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        if (fromDate.length > 0 && toDate.length > 0) {
                          e.currentTarget.style.transform = 'translateY(-1px)'
                          e.currentTarget.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.4)'
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (fromDate.length > 0 && toDate.length > 0) {
                          e.currentTarget.style.transform = 'translateY(0)'
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)'
                        }
                      }}
                    >
                      📊 FILTER & SEARCH
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Form>
        </div>
        <Card
          title={
            <div style={{
              background: 'var(--refund-theme-primary-soft)',
              color: '#111827',
              padding: '12px 20px',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <span>🏛️</span>
              Bid Security Updated to Public Treasury
            </div>
          }
          style={{
            marginTop: '20px',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
          }}
          headStyle={{
            background: 'transparent',
            borderBottom: '1px solid #e5e7eb',
            padding: '0'
          }}
        >
          {/* Enhanced search bar */}
          <div className="search-container" style={{
            width: '100%',
            marginBottom: 16,
            marginRight: '0',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            flexWrap: 'wrap'
          }}>
            <Input
              size="large"
              placeholder="🔍 Quick search in the tables"
              prefix={<ZoomOutOutlined style={{ color: '#6b7280' }}/>}
              onChange={OnRefundRequestSearch}
              style={{
                width: '300px',
                borderRadius: '8px',
                border: '2px solid #e5e7eb',
                transition: 'border-color 0.2s ease'
              }}
            />
          </div>
          <Tabs
            onChange={(key) => handleTabChange(key)}
            type="card"
            size="large"
            defaultActiveKey="bidders"
          >
            <Tabs.TabPane
              tab={
                <span style={{
                  fontWeight: '600',
                  color: '#374151',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px'
                }}>
                  🏛️ Bid Securities/Public Treasury
                </span>
              }
              key="bidders"
            >
              {/* Responsive scroll for table on small devices */}
              <div className="overflow-x-auto md:overflow-x-visible">
              <Spin
                spinning={loading}
                indicator={antIcon}
                tip={
                  <span style={{
                    color: 'var(--refund-theme-primary)',
                    fontWeight: '500'
                  }}>
                    🔄 Loading treasury data...
                  </span>
                }
              >
                <div style={{ width: '100%', overflowX: 'auto' }}>
                  <Table
                    columns={biddersColumns}
                    dataSource={refundRequestList}
                    onChange={handleTableChange}
                    pagination={{
                      ...pagination,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                      showSizeChanger: true,
                      showQuickJumper: true,
                        hideOnSinglePage: false,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        showLessItems: true,
                      style: {
                          background: '#F5F5F5',
                          borderRadius: '8px',
                          padding: '12px',
                          border: '1px solid #e5e7eb',
                          marginTop: '16px'
                      }
                    }}
                    loading={loading}
                    scroll={{ x: 900 }}
                    style={{
                      minWidth: 900,
                      borderRadius: '8px',
                      overflow: 'hidden'
                    }}
                    rowClassName={(record, index) =>
                      index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
                    }
                  />
                </div>
              </Spin>
              </div>
            </Tabs.TabPane>
          </Tabs>
        </Card>
      </div>
    </div>
  )
}

export default PublicTreasury;
